export function handleDisableModalDateTimeChange(
  e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  showAlert: (msg: string, type: "success" | "error") => void,
  setDisableDateTime: (date: Date | null) => void,
  setTimeValue: (time?: string) => void,
  setIsDirty: (dirty: boolean) => void
) {
  if (!e.target.value) {
    setDisableDateTime(null);
    setTimeValue(undefined);
    setIsDirty(true);
    return;
  }

  const [date, time] = e.target.value.split("T");
  const [hours, minutes] = time.split(":").map(Number);

  const updatedDate = new Date(date);
  updatedDate.setHours(hours, minutes);

  const now = new Date();
  const oneMinuteBuffer = 60 * 1000;
  const nowWithBuffer = new Date(now.getTime() - oneMinuteBuffer);

  if (updatedDate < nowWithBuffer) {
    showAlert("You cannot select a past date or time", "error");
    return;
  }
  setDisableDateTime(updatedDate);
  setTimeValue(time);
  setIsDirty(true);
}